// extracted by mini-css-extract-plugin
export var emergencyTicker = "emergency-ticker";
export var marquee = "marquee";
export var marqueeAnimation = "marqueeAnimation";